import { CCol, CInput, CLabel, CRow } from "@coreui/react";
import React from "react";

const LotListViewLotDetails = (props) => {
  const textBoxShow = (lable, value, id = "exampleFormControlInput1") => {
    return (
      <CCol className={"mb-2"} xl={4}>
        <CLabel htmlFor={id}>{lable}</CLabel>
        <CInput value={value === null ? " " : value} disabled id={id} />
      </CCol>
    );
  };

  return (
    <>
      <CRow className="pt-3" xl={12}>
        <CCol className="mb-2" xl={12}>
          <h3 className="titlehr">Lot Details</h3>
        </CCol>
      </CRow>
      <div className="pl-1 pr-1">
        <CRow>
          {textBoxShow("Lot number : ", props.viewListDetails.lotNo)}
          {textBoxShow("Estimated Quantity : ", props.viewListDetails.quantity)}
          {textBoxShow("Purchase Rate : ", props.viewListDetails.purchaseRate)}
          {textBoxShow(
            "Purchase Price : ",
            props.viewListDetails.purchasePrice
          )}

          {textBoxShow(
            "Actual Quantity :",
            props.viewListDetails.actualQuantity
          )}
          {textBoxShow(
            "Godown Quantity : ",
            props.viewListDetails.godownQuantity
          )}
          {textBoxShow(
            "Estimated Emd Amount (10%) : ",
            props.viewListDetails.emdAmount_History 
          )}
           {textBoxShow(
            "Emd Amount (10%) : ",
           
               props.viewListDetails.emdAmount
              
          )}
          {textBoxShow(
            "Estimated Emd Amount (15%) : ",
            props.viewListDetails.addAmount_History
          )}
          {textBoxShow(
            "Emd Amount (15%) : ",
          
              props.viewListDetails.addAmountToDisplay
          )}
              {textBoxShow(
            "Purchaser Name : ",          
             ((props.viewListDetails.companyName == null || props.viewListDetails.companyName == '' )? props.viewListDetails.userName : props.viewListDetails.companyName)
          )}
              {textBoxShow(
            "Purchaser Email : ",
          
              props.viewListDetails.emailId
          )}
        </CRow>
        <CRow>
          {textBoxShow("Society : ", props.viewListDetails.socity)}
          {textBoxShow("District Union : ", props.viewListDetails.districtName)}
          {textBoxShow("Circle Name : ", props.viewListDetails.circleName)}
        </CRow>
      </div>
    </>
  );
};

export default LotListViewLotDetails;
